// Storage Types - Web-specific type definitions
// Split from storage.ts for maintainability
//
// NOTE: The web app owns its own domain types (Owner, Driver, CarInfo,
// CompanyInfo, etc.) — they are defined under ./types/* and re-exported
// through this barrel. `@drivas/shared` is currently consumed only by
// packages/mobile; the web does not import its types, and the web types
// have diverged into supersets. (The earlier plan to make shared the
// canonical source for web types was never carried out — see
// docs/UNFINISHED_WORK_OVERVIEW.md.)
//
// REFACTOR: this file is now a BARREL. The declarations were extracted
// verbatim into ./types/*. storage.ts still does `export * from './storage-types'`,
// and `export *` forwards both types and runtime values, so all importers keep working.

export * from './types/core-types';
export * from './types/driver-certification-types';
export * from './types/driver-employment-types';
export * from './types/company-org-types';
export * from './types/payroll-lonn-types';
export * from './types/accounting-types';
export * from './types/fleet-types';
export * from './types/messaging-support-types';
export * from './types/compliance-internkontroll-types';
